import { Component, OnDestroy, OnInit } from '@angular/core';
import { InfoMessageService } from 'src/app/services/info-message.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-temporary-info-message',
  templateUrl: './temporary-info-message.component.html',
  styleUrls: ['./temporary-info-message.component.scss']
})
export class TemporaryInfoMessageComponent implements OnInit, OnDestroy {
  title: string = "Info";
  description: string = "This is a temporary info component...";
  type: string = "info";
  current_class: string = 'info-container';
  public isVisible: boolean = false;
  private subscription: Subscription = new Subscription();

  constructor(private infoMessageService: InfoMessageService) {}

  ngOnInit(): void {
    this.subscription = this.infoMessageService.getToastData().subscribe(data => {
      this.isVisible = !!data;
      if (data) {
        this.changeContent(data.title, data.description, data.type);
      }
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  changeType() {
    switch(this.type) {
      case "info":
        this.current_class = "info-container";
        break;
      case "success":
        this.current_class = "success-container";
        break;
      case "fail":
          this.current_class = "failure-container";
          break;
      case "warning":
          this.current_class = "warning-container";
          break;
    }
  }

  changeContent(title: string, description: string, type: string) {
    this.title = title;
    this.description = description;
    this.type = type;
    this.changeType();
  }
}